import styled from 'styled-components'

export const CardDescription = styled.span`
	display: block;
	font-size: 14px;
	line-height: 20px;
	margin-top: 9px;
`
